import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
	isEqual, isNull, indexOf, isEmpty,
} from 'lodash';
import { Button } from 'react-bootstrap';
import { Loader } from '@components/common';
import EmptyState from '../components/emptyState';
import Officer from '../components/officer';

class Applicants extends Component {
	shouldComponentUpdate = ({
		isLoading,
		positionId,
		timeZone,
		applicants,
		assignedOfficersIds,
		allowAssign,
	}) => {
		const lastProps = this.props;

		return (
			!isEqual(isLoading, lastProps.isLoading)
			|| !isEqual(positionId, lastProps.positionId)
			|| !isEqual(timeZone, lastProps.timeZone)
			|| !isEqual(applicants, lastProps.applicants)
			|| !isEqual(assignedOfficersIds, lastProps.assignedOfficersIds)
			|| !isEqual(allowAssign, lastProps.allowAssign)
		);
	}

	isApplicantUserAssigned = (applicant) => {
		const { assignedOfficersIds } = this.props;
		return (indexOf(assignedOfficersIds, applicant.UserId) > -1);
	}

	isApplicationPending = (applicant) => (
		isNull(applicant.ApprovedDateTimeUTC)
		&& isNull(applicant.DenialDateTimeUTC)
	)

	displayActionButtons = (applicant) => (
		!this.isApplicantUserAssigned(applicant)
		&& this.isApplicationPending(applicant)
	)

	onUpdateApplication = (type, officerId) => () => {
		const {
			positionId,
			onUpdateApplication,
		} = this.props;

		onUpdateApplication({
			type,
			officerId,
			positionId,
		});
	}

	render() {
		const {
			isLoading,
			positionId,
			timeZone,
			applicants,
			allowAssign,
		} = this.props;

		return (
			<div className="scroll__officers__container">
				<div className="scroll__officers">
					<For
						index="index"
						each="applicant"
						of={applicants}
					>
						<Officer
							key={`applicant_${applicant.Id}_${index}`}
							timeZone={timeZone}
							url={applicant.User.ContactPhotoUrl}
							firstName={applicant.User.FirstName}
							lastName={applicant.User.LastName}
							phone={applicant.User.CellPhone}
							email={applicant.User.Email}
							createDate={applicant.CreateDateUTC}
							officerRank={applicant.User.OfficerRank}
							jurisdiction={applicant.User.JurisdictionName}
							jobsWorked={applicant.TotalJobsWorked}
							upcomingJobs={applicant.UpcomingJobsScheduled}
							totalHours={applicant.User.TotalWorkedHours}
							isRKPay={applicant.User.IsRKPay}
							actions={(
								<Choose>
									<When condition={allowAssign && this.displayActionButtons(applicant)}>
										<Button
											bsStyle="danger"
											className="btn-shadow"
											onClick={this.onUpdateApplication('decline', applicant.UserId)}
										>
											Decline
										</Button>
										<Button
											bsStyle="success"
											className="btn-shadow"
											onClick={this.onUpdateApplication('accept', applicant.UserId)}
										>
											Accept
										</Button>
									</When>
									<When condition={!allowAssign && this.isApplicationPending(applicant)}>
										<div className="tag tag-warning">
											Pending Approval
										</div>
									</When>
									<Otherwise>
										<div
											className={classNames('tag', {
												'tag-success' : !isNull(applicant.ApprovedDateTimeUTC),
												'tag-danger'  : !isNull(applicant.DenialDateTimeUTC),
											})}
										>
											{ !isNull(applicant.ApprovedDateTimeUTC) ? 'Approved' : 'Denied' }
										</div>
									</Otherwise>
								</Choose>
							)}
						/>
					</For>
				</div>
				<If condition={isEmpty(applicants)}>
					<EmptyState
						message="No Applications received"
						positionId={positionId}
					/>
				</If>
				<Loader
					size="small"
					active={isLoading}
				/>
			</div>
		);
	}
}

Applicants.propTypes = {
	allowAssign         : PropTypes.bool,
	applicants          : PropTypes.array,
	assignedOfficersIds : PropTypes.array,
	isLoading           : PropTypes.bool,
	onUpdateApplication : PropTypes.func,
	positionId          : PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
	timeZone : PropTypes.string,
};

Applicants.defaultProps = {
	allowAssign         : true,
	applicants          : [],
	assignedOfficersIds : [],
	isLoading           : false,
	positionId          : '',
	timeZone            : '',
	onUpdateApplication : undefined,
};

export default Applicants;
